import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import BtnIcons from '../../../../api/images/btnIcons';
import { EX_JSON } from '../../../../constants/exampleJson';
import moment from 'moment/moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from '@mui/material/TextField';
import { basicMissionCreateRequest } from '../../../../redux/actions/app/basicActions';
import { convertDecimalToBigNum } from '../../../../utils/convert-decimal-to-big-num';
import Notification from '../../../../components/Notification/Notification';
import { CondDateTimePicker } from '../../../../components';

function basicMissionRegist(props) {
  // -- props --//
  const { readOnly } = props?.location?.state;

  // -- component const --//
  const title = '등록';

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 설정
  const [beginAt, setBeginAt] = useState(moment.utc().format('YYYY-MM-DDTHH:mm'));
  const [endAt, setEndAt] = useState(moment.utc().format('YYYY-MM-DDTHH:mm'));
  const [conditionAt, setConditionAt] = useState(moment.utc().format('YYYY-MM-DDTHH:mm'));
  const [dailyMission, setDailyMission] = useState('');
  const [achieveMission, setAchieveMission] = useState('');
  const [walletNo, setWalletNo] = useState(0);
  const [depositTransactionStatus, setDepositTransactionStatus] = useState(0);

  const [disabledBtn, setDisabledBtn] = useState(false);

  // -- func & handler --//
  const checkRequiredFields = () => {
    const requiredFields = {
      beginAt: '시작 일시',
      endAt: '종료 일시',
      conditionAt: '일일 미션 시작 일시',
    };

    const missingFields = [];

    for (const [key, value] of Object.entries(requiredFields)) {
      if (!eval(key)) {
        missingFields.push(value);
      }
    }

    try {
      const parsedDailyMission = JSON.parse(dailyMission);
      if (!Array.isArray(parsedDailyMission) || !parsedDailyMission.every((mission, index) => {
        const requiredKeys = ['Index', 'TargetCampaigns', 'RequiredTime', 'OpenAt', 'TokenType', 'TokenAmount'];
        const missingKeys = requiredKeys.filter(key => !mission.hasOwnProperty(key));
        if (missingKeys.length > 0) {
          missingFields.push(`일일 미션 내용의 ${index + 1}번째 데이터의 키 '${missingKeys.join(', ')}'가 잘못되었습니다.`);
          return false;
        }
        return true;
      })) {
        if (missingFields.length === 0) {
          missingFields.push('일일 미션 내용(올바른 JSON 형식)');
        }
      }
    } catch (error) {
      missingFields.push('일일 미션 내용(올바른 JSON 형식)');
    }

    try {
      const parsedAchieveMission = JSON.parse(achieveMission);
      if (!Array.isArray(parsedAchieveMission) || !parsedAchieveMission.every((mission, index) => {
        const requiredKeys = ['Index', 'MissionCondition', 'TokenType', 'TokenAmount'];
        const missingKeys = requiredKeys.filter(key => !mission.hasOwnProperty(key));
        if (missingKeys.length > 0) {
          missingFields.push(`업적 미션 내용의 ${index + 1}번째 데이터의 키 '${missingKeys.join(', ')}'가 잘못되었습니다.`);
          return false;
        }
        return true;
      })) {
        if (missingFields.length === 0) {
          missingFields.push('업적 미션 내용(올바른 JSON 형식)');
        }
      }
    } catch (error) {
      missingFields.push('업적 미션 내용(올바른 JSON 형식)');
    }

    return missingFields;
  };

  const handleSubmit = () => {
    // setDisabledBtn(true);

    const missingFields = checkRequiredFields();

    if (missingFields.length > 0) {
      setNotificationMessage(`다음 필수 정보가 입력되지 않았거나 형식이 올바르지 않습니다: ${missingFields.join(', ')}`);
      setShowNotification(true);
      setDisabledBtn(false);
      return;
    }

    dispatch(
      basicMissionCreateRequest({
        beginAt: beginAt,
        endAt: endAt,
        conditionAt: conditionAt,
        dailyData: dailyMission,
        achievementData: achieveMission,
        walletNo: walletNo,
        depositTransactionStatus: depositTransactionStatus,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setNotificationMessage('미션 생성 요청 성공');
          setShowNotification(true);
          setDisabledBtn(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
          setDisabledBtn(false);
        }
      })
    );
  }

  // -- react hooks --//

  // -- render --//
  return (
    <div className='page'>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSectionBack">
        <img
          src={BtnIcons.backIcon}
          className="backIcon"
          onClick={() => {
            window.history.back();
          }}
          alt="goBack"
        />
        <p className="titleText">{title}</p>
      </div>

      <div className="spaceDiv10"/>

      <div className="contentsArea paddingAll">

        <div className="rowDiv flex">

          <div className="titleDiv">
            시작 일시

            <div className="spaceDiv10"/>

            <CondDateTimePicker
              disable={false}
              value={beginAt}
              onChange={(date) => {
                setBeginAt(date.format('YYYY-MM-DDTHH:mm:ss'));
              }}
            />

            {/* <LocalizationProvider dateAdapter={AdapterMoment}> */}
            {/*   <DateTimePicker */}
            {/*     value={beginAt} */}
            {/*     onChange={(date) => { */}
            {/*       setBeginAt(date.format('YYYY-MM-DDTHH:mm:ss')); */}
            {/*     }} */}
            {/*     renderInput={(params) => <TextField {...params} variant="standard" style={{ maxHeight: 32 }}/>} */}
            {/*   /> */}
            {/* </LocalizationProvider> */}
          </div>

          <div className="titleDiv">
            종료 일시

            <div className="spaceDiv10"/>

            <CondDateTimePicker
              disable={false}
              value={endAt}
              onChange={(date) => {
                setEndAt(date.format('YYYY-MM-DDTHH:mm:ss'));
              }}
            />

            {/* <LocalizationProvider dateAdapter={AdapterMoment}> */}
            {/*   <DateTimePicker */}
            {/*     className="endDate" */}
            {/*     value={endAt} */}
            {/*     onChange={(date) => { */}
            {/*       setEndAt(date.format('YYYY-MM-DDTHH:mm:ss')); */}
            {/*     }} */}
            {/*     renderInput={(params) => <TextField {...params} variant="standard" style={{ maxHeight: 32 }}/>} */}
            {/*   /> */}
            {/* </LocalizationProvider> */}
          </div>

        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex">

          <div className="titleDiv">
            일일 미션 시작 일시

            <div className="spaceDiv10" style={{
              fontSize: 10,
              color: '#E90A32'
            }}>
              * 해당 일자와 유저의 가입일 중 늦은 쪽이 일일 미션 오픈 판단의 기준 날짜가 됩니다.
            </div>

            <CondDateTimePicker
              disable={false}
              value={conditionAt}
              onChange={(date) => {
                setConditionAt(date.format('YYYY-MM-DDTHH:mm:ss'));
              }}
            />

            {/* <LocalizationProvider dateAdapter={AdapterMoment}> */}
            {/*   <DateTimePicker */}
            {/*     className="endDate" */}
            {/*     value={conditionAt} */}
            {/*     onChange={(date) => { */}
            {/*       setConditionAt(date.format('YYYY-MM-DDTHH:mm:ss')); */}
            {/*     }} */}
            {/*     renderInput={(params) => <TextField {...params} variant="standard" style={{ maxHeight: 32 }}/>} */}
            {/*   /> */}
            {/* </LocalizationProvider> */}
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex">
          <div className="titleDiv">
            일일 미션 내용(JSON 형태여야 한다)
            <div className="spaceDiv10"/>
            <textarea
              style={{
                height: 'fit-content',
                minHeight: 480,
              }}
              value={dailyMission}
              onChange={(e) => {
                setDailyMission(e.target.value.toString());
              }}
              placeholder={EX_JSON.Mission.daily}
              disabled={readOnly}
            />
          </div>

          <div className="titleDiv">
            업적 미션 내용(JSON 형태여야 한다)
            <div className="spaceDiv10"/>
            <textarea
              style={{
                height: 'fit-content',
                minHeight: 480,
              }}
              value={achieveMission}
              onChange={(e) => {
                setAchieveMission(e.target.value.toString());
              }}
              placeholder={EX_JSON.Mission.achieve}
              disabled={readOnly}
            />
          </div>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <div className="betweenBtn">
        <div className="leftBtn">
          <button
            className="defaultBtn error"
            onClick={() => {
              setDailyMission('');
              setAchieveMission('');
              setDisabledBtn(false);
            }}
            disabled={readOnly}
          >
            내용 비우기
          </button>
        </div>
        <div className="rightBtn">
          <button
            className="defaultBtn"
            onClick={() => {
              handleSubmit();
            }}
            disabled={readOnly || disabledBtn}
          >
            Basic 미션 등록
          </button>
        </div>
      </div>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </div>
  )
}

export default basicMissionRegist;
